// DTM
import React, { Component } from "react";
import styled from "styled-components";

import scale from "../helper/scaling";

import ArticleAbstract from "./ArticleAbstract";

const Wrapper = styled.div`
  width: 100%;
  float: left;
`;
const Inner = styled.div`
  padding: 35px calc(50% - 520px) 65px calc(50% - 520px);
  width: 1040px;
  float: left;

  @media (max-width: 1100px) {
    padding: ${scale(1100, 767, 35, 15, "vw")} 25px
      ${scale(1100, 767, 65, 40, "vw")};
    width: calc(100% - 50px);
  }
  @media (max-width: 700px) {
    padding: 0;
    margin: 23px;
    width: calc(100% - 46px);
  }
`;
const Title = styled.div`
  width: 100%;
  padding-bottom: 42px;

  float: left;
  font-family: Lato;
  font-size: 28px;
  font-weight: 900;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.07;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 28, 24, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 16px;
    padding-bottom: 14px;
  }
`;
const Items = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  @media (max-width: 700px) {
    flex-wrap: wrap;
    align-items: stretch;
  }
`;

class SetIcons extends Component {
  render() {
    let first = this.props.set[0];
    let items = [];
    for (let i in this.props.set) {
      if (i > 0) items.push(this.props.set[i]);
    }
    return (
      <Wrapper>
        <Inner>
          <Title>{first.title}</Title>
          <Items>{items.map(item => <Icon key={item.id} content={item} />)}</Items>
        </Inner>
      </Wrapper>
    );
  }
}

export default SetIcons;

const Item = styled.div`
  width: 180px;
  height: 236px;
  position: relative;

  @media (max-width: 1100px) {
    width: calc(18% - 9px);
    height: ${scale(1100, 767, 236, 160, "vw")};
  }
  @media (max-width: 700px) {
    width: calc(50% - 10px);
    margin: 10px 0;
    height: auto;
    :nth-child(2n) {
      margin-left: 10px;
    }
    :nth-child(2n + 1) {
      margin-right: 10px;
    }
  }
`;
const Image = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 100%; /* 1:1 Aspect Ratio */

  background-repeat: no-repeat;
  background-position: center center;
  background-size: 105%;

  border-radius: 88px;
  border: solid 1px #3949ab;
  @media (max-width: 700px) {
    width: calc(100% - 2px);
    height: 0;
    margin-bottom: 5px;
    position: relative;
    top: 0;
    left: 0;
    border-radius: 200px;
  }
`;
const ItemTitle = styled.div`
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;

  font-family: Lato;
  font-size: 18px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0.3px;
  text-align: center;
  color: rgba(0, 0, 0, 0.85);

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 767, 18, 15, "vw")};
  }
  @media (max-width: 700px) {
    width: 100%;
    position: relative;
    font-size: 13px;
  }
`;

class Icon extends ArticleAbstract {
  render() {
    return (
      <Item {...this.link()}>
        <Image style={this.image()} />
        <ItemTitle>{this.title()}</ItemTitle>
      </Item>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SetIcons.js